export interface Feedback {
  _id?: string;
  comment?: string;
  commentary?: string;
  rate: Rate;
}

export enum Rate {
  Bad = 1,
  Good = 2,
  Excellent = 3,
}
